module.exports = __webpack_public_path__ + "static/media/pic1.78dc1275.jpg";